import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const Container = styled.div`
  width: 100%;
  max-width: 100%;

  .mt-fd {
    height: 100%;
  }

  .row {
    margin-bottom: 0.5rem;
  }

  .no-padding {
    padding: 0 !important;
  }

  .no-margin {
    margin: 0 !important;
  }
    
  .modal-add {
    padding: 6rem 6rem;
    position: fixed;
    background: #27272785;
    top: 0;
    left: 3.8%;
    width: 92.5%;
    height: 94%;

    .modal-fundo {
      width: 100%;
      height: 100%;
      padding: 1rem;
      background: ${Colors.Color26};
      border-radius: 1rem;

      .header-modal {

        .titulo {
          background: #2C2C2C;
          border-radius: 0.5rem;
          padding: 0.3rem 0.8rem 0.3rem 0.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #1A1A1A !important;
          display: flex;
          flex-direction: row;
          width: fit-content;
        
          p {
            font-size: 0.8125rem;
            font-weight: 800;
            color: #6796CF;
            line-height: 0.8rem;
          }
        }
      }

      .body-modal {
        height: calc(100% - 4rem);
      }

      .footer-modal {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        width: 100%;

        button {
          margin-left: 1rem;
        }
      }
    }
  }

`;

export const Quadro = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 0rem 0rem;
  background: ${Colors.Color2};
  border-radius: 0rem;

  .row {
    margin-bottom: 0.5rem;
  }

  .no-padding {
    padding: 0 !important;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0rem;
    display: flex;
    flex-direction: row;

    .title {
      color: ${Colors.Color7};
      font-size: 0.8rem;
      font-weight: 600;
    }

    .title-dia {
      color: ${Colors.Color7};
      font-size: 0.65rem;
      font-weight: 600;
    }

    .div-direita {
      // padding: 0 1rem;
      display: flex;
      flex-direction: row;
      width: 45.8%;

      .w3 {
        width: 33.33%;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0.1rem 0.8rem;
      }
    }

    .div-esquerda {
      display: flex;
      flex-direction: column;
      width: 55%;
      height: 4rem;

      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        height: 2rem;
        width: 100%;
        background: ${Colors.Color26};
        border-left: 2px solid ${Colors.Color2};
        padding: 0rem 0.6rem;

        .movimento {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 0.2rem;
          margin-right: 0.6rem;
          color: #fff;

          i {
            font-size: 0.65rem !important;
            color: ${Colors.Color7};
            margin: 0 0.3rem;
            cursor: pointer;
          }
        }

        p {
          font-size: 0.65rem !important;
        }
      }

      .bottom {
        border-bottom: 2px solid ${Colors.Color2};
        display: flex;
        flex-direction: row;
        height: 2rem;
        width: 100%;

        .w7 {
          background: ${Colors.Color29};
          border-left: 2px solid ${Colors.Color2};
          width: 14.28%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .list-aloca {
    height: 31em;
    position: relative;
    overflow: auto;
    width: 101%;
  }

  .item-body-cli {
    padding: 0 0rem;
    display: flex;
    flex-direction: row;

    .title {
      color: ${Colors.Color7};
      font-size: 0.7rem;
      font-weight: 600;
    }

    .title-dia {
      color: ${Colors.Color7};
      font-size: 0.65rem;
      font-weight: 600;
    }

    .div-direita {
      display: flex;
      flex-direction: row;
      width: 45%;
      background: #242424;
      padding: 0.1rem 0.8rem;
      border-left: 2px solid ${Colors.Color2};
      border-bottom: 2px solid ${Colors.Color2};

      .w9 {
        width: 90%;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .w1 {
        width: 10%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .img {
          width: 1.1rem;
          height: 1.1rem;
          background: #4f4f4f;
          border-radius: 0.4rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          i {
            color: #B1B1B1;
            font-size: 0.8rem;
          }
        }
      }
    }

    .div-esquerda {
      display: flex;
      flex-direction: column;
      width: 55%;
      height: 2.5rem;
      background: #242424;
      padding: 0.1rem 0.8rem;
      border-left: 2px solid ${Colors.Color2};
      border-bottom: 2px solid ${Colors.Color2};

      .top {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        height: 2.5rem;
        width: 100%;
        background: ${Colors.Color26};
        border-left: 2px solid ${Colors.Color2};
        padding: 0rem 0.6rem;

        p {
          font-size: 0.6rem !important;
        }
      }

      .bottom {
        display: flex;
        flex-direction: row;
        height: 2.5rem;
        width: 100%;
      }
    }
  }

  .item-body-proj.proj1 {
    .div-direita {
      background: ${Colors.Color29};
    }

    .div-esquerda {
      background: ${Colors.Color29};
    }
  }

  .item-body-proj.proj2 {
    .div-direita {
      background: ${Colors.Color37};
    }

    .div-esquerda {
      background: ${Colors.Color37};
    }
  }
  
  .item-body-proj {
    padding: 0 0rem;
    display: flex;
    flex-direction: row;

    .title {
      color: ${Colors.Color7};
      font-size: 0.65rem;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .title-dia {
      color: ${Colors.Color7};
      font-size: 0.65rem;
      font-weight: 600;
    }

    .div-direita {
      display: flex;
      flex-direction: row;
      width: 45%;
      height: 2.5rem;

      .w3 {
        width: 33.33%;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-left: 2px solid ${Colors.Color2};
        border-bottom: 2px solid ${Colors.Color2};
        padding: 0.4rem 0.8rem;
      }
    }

    .div-esquerda {
      display: flex;
      flex-direction: column;
      width: 55%;
      height: 2.5rem;

      .top {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        height: 2.5rem;
        width: 100%;
        background: ${Colors.Color26};
        border-left: 2px solid ${Colors.Color2};
        padding: 0rem 0.6rem;

        p {
          font-size: 0.6rem !important;
        }
      }

      .bottom {
        border-bottom: 2px solid ${Colors.Color2};
        display: flex;
        flex-direction: row;
        height: 2.5rem;
        width: 100%;

        .w7 {
          border-left: 2px solid ${Colors.Color2};
          width: 14%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .item-card-azul {
            background: ${Colors.Color31};
            border-left: 4px solid ${Colors.Color32};
          }

          .item-card-verde {
            background: ${Colors.Color33};
            border-left: 4px solid ${Colors.Color34};
          }

          .item-card-amarelo {
            background: ${Colors.Color35};
            border-left: 4px solid ${Colors.Color36};
          }

          .item-card {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            height: 100%;
            padding: 0.2rem 0.35rem 0.2rem 0.35rem;

            .item-card-top {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              
              .title-tipo {
                color: ${Colors.Color30};
                font-size: 0.57rem;
                font-weight: 600;
              }

              .title-total {
                color: ${Colors.Color30};
                font-size: 0.55rem;
                font-weight: 600;
              }
            }
              
            .item-card-bottom {
              display: flex;
              flex-direction: row;
              margin-top: 0.2rem;

              .title-horario {
                color: ${Colors.Color30};
                font-size: 0.45rem;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
`;